<template>
  <form>
    <div class="form-group">
      <div class="app flex-row align-items-center">
        <div class="container col-sm-15">
          <b-col md="6">
            <b-card-group style="width: 200%; height: 300%; margin-top: 500px">
              <b-card style="width: 500px; height: 300%" no-body>
                <b-card-body style="padding: 25px 45px !important">
                  <div v-if="!clientCheck">
                    <div class="Heading">Registar Client</div>
                    <b-input-group class="mb-2 mt-2">
                      <b-form-input
                        type="text"
                        class="form-control input-sm w-20 clientinput"
                        v-model="clientName"
                        placeholder="Enter Client Name"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2 mt-2">
                      <b-form-input
                        type="text"
                        class="form-control input-sm w-20 clientinput"
                        v-model="clientUserName"
                        placeholder="Enter User Name"
                      ></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-2 mt-2">
                      <b-form-input
                        type="password"
                        class="form-control input-sm w-20 clientinput"
                        v-model="password"
                        placeholder="Enter Password"
                      ></b-form-input>
                      <b-input-group class="mb-2 mt-2">
                        <b-form-input
                          type="email"
                          class="form-control input-sm w-20 clientinput"
                          v-model="clientEmail"
                          placeholder="Enter Email"
                        ></b-form-input>
                      </b-input-group>
                    </b-input-group>

                    <div class="justify-content-center text-center">
                      <button
                        type="submit"
                        class="btn primarycolor"
                        @click="registerClient()"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                  <!-- end for category URL and platform URL -->
                  <div v-if="clientCheck">
                    <div class="Heading">Details for Trial Period</div>
                    <b-row
                      style="margin-top: 15px; padding-right: 5px"
                      v-if="registarClient"
                    >
                      <div class="col-md-3 pr-0">
                        <div class="checkbox-btn">
                          <input type="checkbox" value="false" v-model="sov" />
                          <span>SOV</span>
                        </div>
                      </div>
                      <div class="col-md-3 pr-0">
                        <div class="checkbox-btn">
                          <input type="checkbox" value="false" v-model="sos" />
                          <span>SOS</span>
                        </div>
                      </div>
                      <div class="col-md-3 pr-0">
                        <div class="checkbox-btn">
                          <input type="checkbox" value="false" v-model="reviews" />
                          <span>REVIEW</span>
                        </div>
                      </div>
                      <div class="col-md-3 pr-0">
                        <div class="checkbox-btn">
                          <input type="checkbox" value="false" v-model="price" />
                          <span>PRICE</span>
                        </div>
                      </div>
                    </b-row>
                    <div class="d-flex">
                      <div v-for="data of platform" :key="'url' + data.url" class="w-100">
                        <b-input-group class="mb-2 mt-2">
                          <b-form-input
                            type="text"
                            class="form-control w-100 clientinput"
                            placeholder="URL of Platform"
                            v-model="data.platform_url"
                          >
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2 mt-2">
                          <b-form-input
                            type="text"
                            class="form-control input-sm w-25 clientinput"
                            placeholder="Name of Platform"
                            v-model="data.platform_name"
                          >
                          </b-form-input>
                        </b-input-group>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="w-100">
                        <div v-for="data of category" :key="'cat' + data" style="">
                          <b-input-group class="mb-2 mt-2">
                            <b-form-input
                              type="text"
                              class="form-control input-sm w-100 clientinput"
                              placeholder="URL of Category/Search"
                              v-model="data.category_url"
                            >
                            </b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-2 mt-2">
                            <b-form-input
                              type="text"
                              class="form-control input-sm w-100 clientinput"
                              placeholder="Name of Category/Search"
                              v-model="data.category_name"
                            >
                            </b-form-input>
                          </b-input-group>
                          <multiselect
                            v-model="data.result_type"
                            :options="['Category', 'Search']"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            placeholder="Analysis Type"
                            :preselect-first="false"
                            class="input-sm w-100"
                            :searchable="false"
                            :show-labels="false"
                          >
                          </multiselect>
                        </div>
                      </div>
                      <span
                        ><button @click="addCategory" class="saveBtn">
                          <i class="fa fa-plus"></i></button
                      ></span>
                    </div>
                    <div class="d-flex">
                      <div class="w-100">
                        <b-input-group
                          class="mb-2 mt-2"
                          v-for="data of productList"
                          :key="'pro' + data"
                        >
                          <b-form-input
                            type="text"
                            class="form-control w-100 clientinput"
                            placeholder="Product URL"
                            v-model="data.url"
                          >
                          </b-form-input>
                          <b-form-input
                            type="text"
                            class="form-control w-100 clientinput"
                            placeholder="Product Name"
                            v-model="data.name"
                          >
                          </b-form-input>
                          <div class="pr-0 mt-2 d-flex justify-content-end">
                            <div class="checkbox-btn">
                              <input
                                type="checkbox"
                                value="false"
                                v-model="data.is_primary"
                              />
                              <span>Your Brand’s Product</span>
                            </div>
                          </div>
                        </b-input-group>
                      </div>
                      <span @click="addProductList"
                        ><button class="saveBtn">
                          <i class="fa fa-plus"></i></button
                      ></span>
                    </div>
                    <div class="d-flex">
                      <div class="w-100">
                        <div v-for="data of comp" :key="'comp' + data">
                          <b-input-group class="mb-2 mt-2">
                            <b-form-input
                              type="text"
                              class="form-control input-sm w-25 clientinput"
                              placeholder="Competitor's Product URL"
                              v-model="data.url"
                            >
                            </b-form-input>
                          </b-input-group>
                          <b-input-group class="mb-2 mt-2">
                            <b-form-input
                              type="text"
                              class="form-control input-sm w-25 clientinput"
                              placeholder="Competitor's Product Name"
                              v-model="data.name"
                            >
                            </b-form-input>
                          </b-input-group>
                        </div>
                      </div>
                      <span
                        ><button class="saveBtn" @click="addComp">
                          <i class="fa fa-plus"></i></button
                      ></span>
                    </div>
                    <div class="justify-content-center text-center">
                      <button
                        type="submit"
                        class="btn primarycolor"
                        @click="submitDetails"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "form",
  components: {
    Multiselect,
  },
  data: () => {
    return {
      competitorValue: "",
      primaryDropdown: "",
      competitor: "",
      clientName: "",
      password: "",
      email: "",
      clientUserName: "",
      clientEmail: "",
      registarClient: true,
      // form variable
      platform: [{ platformURL: "" }],
      resutlType: ["Category", "Search"],
      platform: [
        {
          platform_url: "",
          platform_name: "",
        },
      ],
      category: [
        {
          category_url: "",
          category_name: "",
          result_type: "",
        },
      ],
      productList: [
        {
          url: "",
          name: "",
          is_primary: false,
        },
      ],
      sov: false,
      sos: false,
      reviews: false,
      price: false,
      primary: false,
      comp: [
        {
          url: "",
          name: "",
        },
      ],
      clientCheck: false,
    };
  },

  methods: {
    addClient() {
      let url = "/api/india_clients/client";
      let payload = {
        client: this.clientName,
      };
      // this.$http.post(url, payload).then((Response) => {
      //     const resData = Response.data
      //     console.log(resData);
      // })
    },
    isValid(url) {
      const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
      return pattern.test(url);
    },
    registerClient() {
      let self = this;
      if (!self.clientName.length) {
        this.$bvToast.toast(`Enter Client Name`, {
          autoHideDelay: 5000,
          variant: "error",
        });
        return false;
      }

      let url = "/api/reviews/register";
      let payload = {
        username: self.clientUserName,
        password: self.password,
        email: self.clientEmail,
        is_demo: true,
        client: self.clientName,
      };
      this.$http.post(url, payload).then(
        (res) => {
          self.clientCheck = true;
          this.$bvToast.toast(`Registar`, {
            autoHideDelay: 5000,
            variant: "success",
          });
        },
        (err) => {
          this.$bvToast.toast(`User Exists`, {
            autoHideDelay: 5000,
            variant: "error",
          });
        }
      );
    },

    submitDetails() {
      let url = "/api/india_clients/products";
      let payload = {
        clientName: this.clientName,
        sov: this.sov,
        sos: this.sos,
        review: this.reviews,
        price: this.price,
        platform: this.platform,
        category: this.category,
        product_list: this.productList,
        comp: this.comp,
      };
      this.$http.post(url, payload).then(
        (Response) => {
          self.emptyVariable();
          this.$bvToast.toast(`Success`, {
            autoHideDelay: 5000,
            variant: "success",
          });
        },
        (err) => {
          this.$bvToast.toast(`Technical Error`, {
            autoHideDelay: 5000,
            variant: "error",
          });
        }
      );
    },
    // addition of dynemic fields
    addCategory() {
      this.category.push({
        category_url: "",
        category_name: "",
        result_type: "",
      });
    },
    addProductList() {
      this.productList.push({
        url: "",
        name: "",
        is_primary: false,
      });
    },
    addComp() {
      this.comp.push({
        url: "",
        name: "",
      });
    },
    emptyVariable() {
      self.platform = [{ platformURL: "" }];
      self.resutlType = ["Category", "Search"];
      self.platform = [
        {
          platform_url: "",
          platform_name: "",
        },
      ];
      self.category = [
        {
          category_url: "",
          category_name: "",
          result_type: "",
        },
      ];
      self.productList = [
        {
          url: "",
          name: "",
          is_primary: false,
        },
      ];
      self.sov = false;
      self.sos = false;
      self.reviews = false;
      self.price = false;
      self.primary = false;
      self.comp = [
        {
          url: "",
          name: "",
        },
      ];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.container {
  margin-top: -500px;
}

.justify-content-center {
  margin-top: 20px;
}

.form-check-label {
  font-size: 20px;
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
  font-size: large;
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
  font-size: large;
}

.checkbox-btn input {
  margin: 4px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
  font-size: large;
}

.btn-primary {
  margin-bottom: 20px;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.form-control::placeholder {
  font-size: large;
  color: var(--primary_brand-40) !important;
  font-family: "poppins" !important;
  padding: 1.375rem 0.75rem !important;
  font-size: 1rem !important;
  border-radius: 1.5rem !important;
}

.form-control:focus {
  box-shadow: none !important;
  outline: none !important;
  border: 2px solid rgb(228, 231, 234) !important;
}

.clientinput {
  /* margin-right: -5px !important; */
  /* border-radius: 0px 10px 10px 0px !important; */
  border-left: 0px !important;
  border-color: rgb(228, 231, 234) !important;
  height: 45px !important;
  margin-top: 15px !important;
  border-color: var(--primary_brand-40) !important;
  border-left: 1px solid var(--primary_brand-40) !important;
  font-size: 18px !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

.saveBtn {
  background-color: #b3bcff;
  border-radius: 0;
  border: none;
  width: 60px;
  height: 35px;
  margin-left: 10px;
  margin-top: 20px;
}

.saveBtn:active {
  background-color: #b3bcff !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.page-heading {
  margin-left: 0.2rem;
  padding-left: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: var(--primary_brand);
  width: 13%;
  margin-top: 15px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.primarycolor:focus {
  box-shadow: none !important;
  outline: none !important;
  background: var(--primary_brand);
}
.Heading {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: var(--base_color);
}
</style>
